module.exports = __webpack_public_path__ + "static/img/adventure_cal.437cce7.jpg";